<template>
  <div id="pagination">
    <div class="clickPage">
      <ul class="ulpage">
        <li
          class="prev"
          :class="{ pageStyleActive: currentPage === 1 }"
          @click="prevPage"
        >
          上一页
        </li>
        <li class="totalList" @click="goToInputPage">
          <div class="curTolStyle">
            <span>{{ currentPage }}/{{ total }}页</span>
          </div>
          <div class="img">
            <img src="../../../assets/index/c3.png" width="16" height="16" />
          </div>
        </li>
        <li class="totalList1" v-if="this.$route.path!='/policyMate'">
          共{{ totalLists }}条
        </li>
        <li
          class="next"
          :class="{ pageStyleActive: currentPage === total }"
          @click="nextPage"
        >
          下一页
        </li>
      </ul>
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      get-container="body"
    >
      <div style="height: 160px;">
        <div class="title-box">
          <span @click="closePopup">取消</span>
          <span class="jump-title">请输入页码</span>
          <span @click="confirmInputNum">确定</span>
        </div>
        
        <div class="input-box">
          <div class="left">跳至</div>
          <div class="center">
            <van-cell-group>
              <van-field
                v-model="pageNum"
                center
                clearable
                type="number"
                maxlength="7"
                input-align="center"
                error-message-align="center"
                placeholder="请输入页码"
                class="pageSize"
              />
            </van-cell-group>
          </div>
          <div class="right">页</div>
        </div>
        <!-- <div class="btn-buju">
          <van-button
            style="width: 30%;border-radius: 30px;height: 40px;"
            type="default"
            @click="closePopup"
            >取消</van-button
          >
          <van-button
            style="width: 30%;border-radius: 30px;height: 40px;"
            type="info"
            @click="confirmInputNum"
            >确定</van-button
          >
        </div> -->
      </div>
    </van-popup>
    <login ref="alertModel" @refreshProtect="refreshProtect"></login>
  </div>
</template>

<script>
import Login from "@/components/common/login";
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    totalLists: {
      type: Number,
      default: 0,
    },
    isHaveNumber: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Login,
  },
  computed: {
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    isProtect() {
      return this.$store.state.search.isProtect;
    },
    warningLevel() {
      return this.$store.state.search.warningLevel;
    },
    warningText() {
      return this.$store.state.search.warningText;
    },
  },
  data() {
    return {
      show: false, // 弹出框
      pageNum: "",
      pattern: /^[1-9][0-9]*$/,
      errMsg: {
        message: "",
      },
    };
  },
  methods: {
    prevPage() {
      // 上一页
      this.$emit("prevPage");
    },
    nextPage() {
      // 下一页
      // console.log('1uu', this.warningLevel)
      if(this.isHaveNumber) {
        this.$refs.alertModel.changeShowLogin(true);
        this.$notify({
          message: "请先登录",
          type: "warning",
          duration: 3000,
        });
        return
      }
      if (this.isProtect) {
        switch (this.warningLevel) {
          case 1:
            this.$refs.alertModel.changeShowLogin(true);
            this.$notify({
              message: "请先登录",
              type: "warning",
              duration: 3000,
            });
            break;
          case 2:
            this.$dialog
              .confirm({
                title: "提示",
                message: this.warningText,
                confirmButtonText: "在线商城",
                cancelButtonText: "取消",
              })
              .then(() => {
                this.$router.push("/onlineMall");
              })
              .catch((err) => {
                console.log(err);
              });
            break;
          case 3:
            this.$dialog
              .confirm({
                title: "提示",
                message: this.warningText,
                confirmButtonText: "在线商城",
                cancelButtonText: "取消",
              })
              .then(() => {
                this.$router.push("/onlineMall");
              })
              .catch((err) => {
                console.log(err);
              });
            break;
          default:
            break;
        }
        return;
      } else if (this.userId || this.wxgenerateid) {
        this.$emit("nextPage");
      } else {
        this.$notify({
          message: "请先登录",
          type: "warning",
        });
        this.$refs.alertModel.changeShowLogin(true); // 弹出登录框
      }
    },
    goToInputPage() {
      if(this.isHaveNumber) {
        this.$refs.alertModel.changeShowLogin(true);
        this.$notify({
          message: "请先登录",
          type: "warning",
          duration: 3000,
        });
        return
      }
      // 跳转到指定的页面
      if (this.isProtect) {
        switch (this.warningLevel) {
          case 1:
            this.$refs.alertModel.changeShowLogin(true);
            this.$notify({
              message: "请先登录",
              type: "warning",
              duration: 3000,
            });
            break;
          case 2:
            this.$dialog
              .confirm({
                title: "提示",
                message: this.warningText,
                confirmButtonText: "在线商城",
                cancelButtonText: "取消",
              })
              .then(() => {
                this.$router.push("/onlineMall");
              })
              .catch((err) => {
                console.log(err);
              });
            break;
          case 3:
            this.$dialog
              .confirm({
                title: "提示",
                message: this.warningText,
                confirmButtonText: "在线商城",
                cancelButtonText: "取消",
              })
              .then(() => {
                this.$router.push("/onlineMall");
              })
              .catch((err) => {
                console.log(err);
              });
            break;
          default:
            break;
        }
        return;
      } else if (this.userId) {
        this.show = true;
        this.pageNum = this.currentPage;
        this.errMsg.message = "";
      } else {
        this.$notify({
          message: "请先登录",
          type: "warning",
        });
        this.$refs.alertModel.changeShowLogin(true); // 弹出登录框
      }
    },
    // 传至政策匹配页父组件
    refreshProtect() {
      this.$emit('refreshProtect')
    },
    closePopup() {
      this.show = false;
    },
    confirmInputNum() {
      if (!this.pageNum || !this.pattern.test(this.pageNum)) {
        this.show = false;
        this.$emit("jumpToPageSize", 1);
      } else if (this.pattern.test(this.pageNum)) {
        let num = parseInt(this.pageNum);
        if (num <= this.total) {
          this.show = false;
          this.$emit("jumpToPageSize", num);
        } else if (num > this.total) {
          this.show = false;
          this.$emit("jumpToPageSize", this.total);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@--border-color: #ebedf0;
@--border-top-color: #f5f6f7;
.pageSize {
  height: 0.88rem !important;
}
#pagination {
  .clickPage {
    height: 1.06667rem;
    line-height: 1.06667rem;
    background-color: #F7F8FA;
    .ulpage {
      display: flex;
      text-align: center;
      color: #666666;
      .prev {
        border: 1px solid @--border-color;
        flex: 0 0 25%;
      }
      .totalList {
        flex: 0 0 28%;
        border-top: 1px solid #ebedf0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #EDEEF0;
        .curTolStyle {
          color: #666666;
        }
        .img {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .totalList1 {
        flex: 0 0 22%;
        color: #646566;
        border-top: 1px solid #ebedf0;
      }
      .next {
        border: 1px solid @--border-color;
        flex: 0 0 25%;
      }
    }
  }
  .pageStyleActive {
    color: #c7bdb5;
    background-color: #fbfcfd;
  }
}
</style>
<style lang="less">
.title-box {
  text-align: center;
  margin: 0px 0 30px 0;
  background-color: #F2F2F2;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  .jump-title {
    color: #000;
    font-size: 17px;
    font-weight: bold;
  }
}
.input-box {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  .center {
    flex: 0 0 120px;
    border: 1px solid #715641;
    .van-field__control {
      color: #000000;
    }
  }
  .left {
    margin-right: 8px;
  }
  .right {
    margin-left: 8px;
  }
}
.btn-buju {
  margin: 36px 0 37px;
  display: flex;
  justify-content: space-between;
  &:before,
  &:after {
    content: "";
    display: block;
  }
}
</style>
